// @flow
import PageHeading from "../../components/PageHeading";
import React from "react";

type Props = {
  title: string,
  gameCount?: number,
};

function SchedulePageHeading({ title, gameCount }: Props) {
  const subInfo =
    gameCount != null && gameCount > 1 ? `${gameCount} Spiele` : undefined;
  return <PageHeading subInfo={subInfo}>{title}</PageHeading>;
}

export default SchedulePageHeading;
